import { h } from "preact"

import './matriculacion-skeleton.scss'

export default function MatriculacionSkeleton() {
    /** Render **/
    return (
        <div className="matriculacion-skeleton">
            <div className="matriculacion-skeleton__badge" />
            <div className="matriculacion-skeleton__title" />

            <div className="matriculacion-skeleton__box">
                <div className="matriculacion-skeleton__line matriculacion-skeleton__line--w80 mb-1" />
                <div className="matriculacion-skeleton__line matriculacion-skeleton__line--w40" />
            </div>

            <div className="matriculacion-skeleton__section-title" />

            <div className="matriculacion-skeleton__list">
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="matriculacion-skeleton__item">
                        <div className="matriculacion-skeleton__check" />
                        <div className="matriculacion-skeleton__line" />
                        <div className="matriculacion-skeleton__price" />
                    </div>
                ))}
            </div>

            <div className="matriculacion-skeleton__section-title" />

            <div className="matriculacion-skeleton__list">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="matriculacion-skeleton__item">
                        <div className="matriculacion-skeleton__check" />
                        <div className="matriculacion-skeleton__line" />
                        <div className="matriculacion-skeleton__price" />
                    </div>
                ))}
            </div>

            <div className="matriculacion-skeleton__section-title" />

            <div className="matriculacion-skeleton__list">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="matriculacion-skeleton__item">
                        <div className="matriculacion-skeleton__check" />
                        <div className="matriculacion-skeleton__line" />
                        <div className="matriculacion-skeleton__price" />
                    </div>
                ))}
            </div>

            <div className="matriculacion-skeleton__totals d-flex flex-column flex-bottom">
                <div className="matriculacion-skeleton__line matriculacion-skeleton__line--w40" />
                <div className="matriculacion-skeleton__line matriculacion-skeleton__line--w20" />
            </div>

            <div className="d-flex flex-column flex-bottom">
                <div className="matriculacion-skeleton__button" />
            </div>
        </div>
    )
}